<template lang="">
    <div>
        <div class="image_mian"> <span class="fr"><img style="width: 250px;" src="../assets/images/logo.jpg" /></span> </div>
        <div class="image_mian pt50">
            <div class="fl"><img src="../assets/images/home1.jpg" /></div>
        </div>
        <!-- <div class="image_mian pt20" id="big_box">
            <table width="100%" border="0" cellspacing="0" cellpadding="0">
                <tr>
                    <td id="show_box" valign="top">
                        <table width="100%" border="0" cellspacing="0" cellpadding="0">
                            <tr>

                                <td><a href="/product/view_{$item['id']}.html"><img src="{$item['picture']}" /></a></td>

                            </tr>
                        </table>
                    </td>
                    <td id="hide_box" valign="top">&nbsp;</td>
                </tr>
            </table>
        </div> -->
        <div class="image_mian pt50">
            <div class="image_client_pic" style="width: auto;"><img src="../assets/images/image_client.jpg" /></div>
            <div class="image_client">
                <div class="client_box">
                    <div>
                        <swiper :options="homeSwiper">
                            <swiper-slide v-for="(item,index) in partnerList" :key="index" style="width: 104px">
                                <a :href="item.link" target="_blank">
                                    <img :src="item.picture" />
                                </a>
                            </swiper-slide>
                        </swiper>
                    </div>
                </div>

            </div>
            <div class="image_language">
                <router-link to="/en/home" class="image_english"></router-link>
                <router-link to="/home" class="image_china"></router-link>
            </div>
        </div>
        <div style="text-align: center;margin-top: 50px">
            <p><a target="_blank" href="https://beian.miit.gov.cn/">{{linkList[0].icp_number}}</a></p>
        </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                linkList: [],
                partnerList: [],
                homeSwiper: {
                    slidesPerView: 'auto', // 自动计算每个slide的宽度
                    loop: true, // 循环模式
                    speed: 4000,
                    spaceBetween: 50, // slide之间的间距
                    centeredSlides: true, // 居中显示当前slide
                    autoplay: {
                        delay: 0, // 自动播放间隔时间
                        disableOnInteraction: false // 用户交互后继续自动播放
                    }
                }
            }
        },
        mounted() {
            this.getPartner();
            this.getLink();
        },
        methods: {
            async getPartner() {
                let res = await this.$request.post('partner/getAll')
                if (res.data.code === 0) {
                    this.partnerList = res.data.data
                }
            },
            async getLink() {
                let res = await this.$request.post('seo/getpaginate')
                if (res.data.code === 0) {
                    this.linkList = res.data.data.data
                }
            }
        },
    }
</script>
<style lang="css" scoped>
    .image_client_pic {
        width: 500px;
        /* 设置容器宽度 */
        margin: 0 auto;
        /* 居中显示 */
    }

    .client_box {
        width: 100%;
    }

    .swiper-container {
        width: 100%;
    }

    .swiper-slide {
        width: 100px;
        /* 每个slide的宽度 */
        height: auto;
        /* 高度自适应 */
    }

    .swiper-slide img {
        width: 100%;
        /* 图片宽度100% */
        height: auto;
        /* 高度自适应 */
    }

    .client_box /deep/ .swiper-wrapper{

transition-timing-function:linear !important;

}
</style>